import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Header from 'components/Header/index'
import TopNav from 'components/TopNav'
import Sidebar from 'containers/SideNav/index'
import Footer from 'components/Footer'
import { ABOVE_THE_HEADER, BELOW_THE_HEADER, COLLAPSED_DRAWER, FIXED_DRAWER, HORIZONTAL_NAVIGATION } from 'constants/ActionTypes'
import { isIOS, isMobile } from 'react-device-detect'
import asyncComponent from '../util/asyncComponent'
import { switchConnectionStatus } from 'actions/Setting'

import ScriptLog from './routes/ScriptLog'

class App extends React.Component {

  componentWillMount () {
    const updateIndicator = () => {
      this.props.switchConnectionStatus(!navigator.onLine)
    }

    window.addEventListener('online', updateIndicator)
    window.addEventListener('offline', updateIndicator)
    updateIndicator()
  }

  render () {
    const {match, drawerType, navigationStyle, horizontalNavPosition} = this.props
    const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'fixed-drawer' : drawerType.includes(COLLAPSED_DRAWER) ? 'collapsible-drawer' : 'mini-drawer'

    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
      document.body.classList.add('ios-mobile-view-height')
    }
    else if (document.body.classList.contains('ios-mobile-view-height')) {
      document.body.classList.remove('ios-mobile-view-height')
    }

    document.body.classList.add('blue')

    return (
      <div className={`app-container ${drawerStyle}`}>
        <Sidebar/>
        <div className="app-main-container">
          <div
            className={`app-header ${navigationStyle === HORIZONTAL_NAVIGATION ? 'app-header-horizontal' : ''}`}>
            {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === ABOVE_THE_HEADER) &&
            <TopNav styleName="app-top-header"/>}
            <Header/>
            {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) &&
            <TopNav/>}
          </div>

          <main className="app-main-content-wrapper">
            <div className="app-main-content">
              <Switch>
                <Route path={`${match.url}script-log`} component={ScriptLog}/>
                <Route path={`${match.url}projects`} component={asyncComponent(() => import('./routes/Projects'))}/>
                <Route component={asyncComponent(() => import('components/Error404'))}/>
              </Switch>
            </div>
            <Footer/>
          </main>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({settings}) => {
  const {drawerType, navigationStyle, horizontalNavPosition} = settings
  return {drawerType, navigationStyle, horizontalNavPosition}
}
export default withRouter(connect(mapStateToProps, {switchConnectionStatus})(App))



// WEBPACK FOOTER //
// ./app/index.js